export enum ClientLocalStateKeys {
  WelcomeStepDisplayed = 'welcomeStepDisplayed',
  AiStatusProjectDescriptionImproved = 'aiStatusProjectDescriptionImproved',
  AiStatusProjectOrchestrationForEntitiesTriggered = 'aiStatusProjectOrchestrationForEntitiesTriggered',
  SocialMediaShared = 'socialMediaShared'
}
